import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-wc-blue text-white" data-id="element-131">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center gap-8 bg-white/10 backdrop-blur-sm p-8 md:p-12 rounded-3xl border border-white/20" data-id="element-133">
          <div className="flex-shrink-0" data-id="element-134">
            <div className="w-24 h-24 bg-wc-yellow rounded-full flex items-center justify-center shadow-lg" data-id="element-135">
              <ShieldCheck className="w-12 h-12 text-wc-dark" data-id="element-136" />
            </div>
          </div>

          <div className="text-center md:text-left" data-id="element-137">
            <h2 className="text-3xl md:text-4xl font-display mb-4" data-id="element-138">
              🔒 GARANTÍA TOTAL
            </h2>
            <p className="text-xl font-bold text-wc-yellow mb-2" data-id="element-139">
              Acá no hay riesgo para vos.
            </p>
            <p className="text-lg text-blue-100 mb-4" data-id="element-140">
              Si después de recibir el pack tenés algún problema con la descarga
              o con los archivos...
            </p>
            <p className="text-lg text-white font-medium bg-white/10 p-4 rounded-xl border-l-4 border-wc-yellow" data-id="element-141">
              Te ayudamos personalmente hasta que todo funcione. Nuestro soporte
              está para acompañarte en todo el proceso. Sin vueltas, sin
              excusas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}